// extracted by mini-css-extract-plugin
module.exports = {"CategoryCard":"CategoryCard_CategoryCard__1yeiS"};